import { createFileRoute, redirect, useSearch } from "@tanstack/react-router";

import { ScreenSpinner, TimedLoader } from "@/components";
import { postPurchaseRecommendationsSearchSchema } from "@/domains/surveys/models/schemas";
import { usePostPurchaseRecommendations } from "@/domains/surveys/queries/use-post-purchase-recommendations";
import { usePostPurchaseSurveyParams } from "@/domains/surveys/queries/use-post-purchase-survey-params";
import { Heading } from "@/ui";
import {
  HowCarePlansWorkCarousel,
  ReOrderProductsCard,
  SafetyInformationCard,
  UpsellCareplanCard,
  UpsellProductsCard,
} from "./-components";

const PostPurchaseRecommendations = () => {
  const { flow_uuid, order_id } = useSearch({ from: "/_guest/post-purchase/recommendations/" });
  const { data: recommendations } = usePostPurchaseRecommendations(flow_uuid);
  const { surveyParams } = usePostPurchaseSurveyParams(order_id);

  if (!surveyParams) {
    return <ScreenSpinner />;
  }

  if (!recommendations) {
    return (
      <div className="flex h-dvh flex-col">
        <TimedLoader>
          <Heading level={2}>Thanks for sharing.</Heading>
          <Heading level={3}>
            Our clinician-trained guidance engine is thinking. Please sit tight for a moment...
          </Heading>
        </TimedLoader>
      </div>
    );
  }

  return (
    <div className="flex w-full flex-col items-center gap-7 px-4 py-8 sm:px-6 md:gap-14 md:py-20">
      <div className="flex max-w-4xl flex-col gap-7 md:gap-14">
        <ReOrderProductsCard recommendations={recommendations} surveyParams={surveyParams} />
        <UpsellProductsCard recommendations={recommendations} surveyParams={surveyParams} />
        <UpsellCareplanCard />
      </div>
      <div className="w-full">
        <HowCarePlansWorkCarousel />
      </div>
      <div className="flex max-w-4xl flex-col gap-7 md:gap-14">
        <SafetyInformationCard />
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_guest/post-purchase/recommendations/")({
  component: PostPurchaseRecommendations,
  validateSearch: postPurchaseRecommendationsSearchSchema,
  onError: (error) => {
    if (error.routerCode === "VALIDATE_SEARCH") {
      throw redirect({ to: "/" });
    }
  },
});
